
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Loader2, ExternalLink, CheckCircle, AlertCircle } from "lucide-react";

interface EmailTestResultProps {
  emailTestResult: any;
  isValidating: boolean;
  onTestEmail: () => Promise<void>;
}

export function EmailTestResult({ emailTestResult, isValidating, onTestEmail }: EmailTestResultProps) {
  if (!emailTestResult) {
    return (
      <Button 
        onClick={onTestEmail} 
        disabled={isValidating}
        className="w-full"
      >
        {isValidating ? (
          <>
            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            Sending Test Email...
          </>
        ) : (
          <>
            <ExternalLink className="w-4 h-4 mr-2" />
            Send Test Email Notification
          </>
        )}
      </Button>
    );
  }

  return (
    <div className="bg-slate-50 p-4 rounded-lg">
      <div className="flex items-center space-x-2 mb-3">
        {emailTestResult.success ? (
          <>
            <CheckCircle className="h-5 w-5 text-green-500" />
            <span className="font-medium text-green-600">Email notification sent successfully</span>
          </>
        ) : (
          <>
            <AlertCircle className="h-5 w-5 text-red-500" />
            <span className="font-medium text-red-600">Email notification failed</span>
          </>
        )}
      </div>
      
      {emailTestResult.success && (
        <div className="space-y-2">
          <div className="flex justify-between">
            <span className="text-sm text-slate-500">Recipient:</span>
            <span className="text-sm font-medium">{emailTestResult.details?.ownerEmail}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-sm text-slate-500">Sent:</span>
            <span className="text-sm font-medium">{new Date(emailTestResult.details?.testTime).toLocaleString()}</span>
          </div>
          {emailTestResult.details?.emailResult && (
            <div className="mt-2">
              <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
                Email Delivered
              </Badge>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
